import { useState, useEffect } from 'react';
import { Dispatch } from 'redux';
import { getUserAndPolicyDetails } from '@/components/fakeDoor/api';
import {
    setUserData,
    setUserType,
    setUserDataLoading,
    setIsMobile,
    getUserDetails,
} from '@/store/modules/userDataSlice';
import Cookies from 'js-cookie';
import growthbook from '@/utils/growthbook';
import {
    initAckoAnalytics,
    identifyEvent,
} from '@acko-tech/building-blocks.ui.acko-analytics';
import { getUserIdFromCookie } from '@/utils/common';
import { useSelector } from 'react-redux';
import useProtectedRoute from './useProtectedRoutes';

interface UserDetails {
    name: string;
    mobile_number: string;
}

//this hook is to fetch  the user details like user type ,name and number

const useUserData = (store: any) => {
    const [loading, setLoading] = useState<boolean>(true);

    const [userDetails, setUserDetails] = useState<UserDetails>({
        name: '',
        mobile_number: '',
    });
    const userId = getUserIdFromCookie();
    const userPhone = Cookies.get('login_phone') || '';
    console.log(userPhone, 'mobile');
    const isMobileDevice = (): boolean => {
        //return window.matchMedia('(max-width: 767px)').matches; //Todo:- once desktop flow is live
        return true;
    };

    useEffect(() => {
        const state = store.getState();
        const userDataFromStore = state?.userData?.userData;
        const isUserDataAvailable = !!userDataFromStore?.phoneNumber;
        // Only fetch data if it's not available in Redux store
        if (!isUserDataAvailable) {
            const fetchUserData = async () => {
                store.dispatch(setIsMobile(isMobileDevice()));
                try {
                    store.dispatch(setUserDataLoading(true));

                    const data: any = await getUserAndPolicyDetails();

                    console.log('get-user-details', data?.userDetails?.name);

                    // Check for policy details response
                    if (data?.policyDetails) {
                        // Set user type in Redux store
                        store.dispatch(
                            setUserType(data?.policyDetails?.userType || 'User')
                        );
                    }

                    // Check for user details response
                    if (data?.userDetails) {
                        // Set user data in Redux store
                        store.dispatch(
                            setUserData({
                                userName:
                                    (data?.userDetails?.first_name || '') +
                                    ' ' +
                                    (data?.userDetails?.last_name || ''),
                                phoneNumber: data?.userDetails?.phone || '',
                                email: data?.userDetails?.email || '',
                            })
                        );
                        // Update user details state
                        setUserDetails({
                            name: data?.userDetails?.name || '',
                            mobile_number: data?.userDetails?.phone || '',
                        });
                    }
                } catch (error) {
                    console.error('Error fetching data:', error);
                } finally {
                    store.dispatch(setUserDataLoading(false));
                }
            };

            fetchUserData();
        } else {
            // If data is already available, set it to the local state
            setUserDetails({
                name: userDataFromStore.userName || '',
                mobile_number: userDataFromStore.phoneNumber || '',
            });
        }
        userId &&
            // Identify event for analytics
            identifyEvent(
                userId?.substring(0, userId?.indexOf(':') - 1) || '',
                {}
            );
    }, []);

    // Return loading state and user details
    return { userDetails };
};

export default useUserData;
